module.exports = __webpack_public_path__ + "img/labourday2015.7da410ab.jpg";